/**
 * Возвращает индекс следующего элемента.
 * Если строка полностью заполнена, возвращает индекс последнего элемента.
 */
export const getNextIndex = (value, length) => {
  const nextIndex = value.length;
  return nextIndex >= length ? nextIndex - 1 : nextIndex;
};